import React, { useEffect, useState } from 'react';
import { Add_Period_Api } from '../../API/PeriodApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Layout, Row } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // استایل‌های Quill
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
const persianToLatinDigits = (str) => {
  if (!str) return '';
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  let newStr = str;
  for (let i = 0; i < 10; i++) {
    const regex = new RegExp(persianDigits[i], 'g');
    newStr = newStr.replace(regex, latinDigits[i]);
  }
  return newStr;
};

// تابع کمکی برای تبدیل DateObject به رشته با فرمت و اعداد لاتین برای API
const formatDateForApi = (dateObject) => {
  if (!dateObject) return '';
  const formattedDate = dateObject.format('YYYY-MM-DD');
  return persianToLatinDigits(formattedDate);
};

// =================================================================
export const AddPeriodComponent = ({ setLoading, showMessage, categoryId, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm();
    const [comment, setComment] = useState('');
    const [additionalFileComment, setAdditionalFileComment] = useState('');

    // =================================================================
    useEffect(() => {
        form.setFieldsValue({ isActive: true, isLottery: true });
    }, [form]);

    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            const formattedValues = {
                ...values,
                categoryId: categoryId,
                from_Shamsi: formatDateForApi(values.from_Shamsi),
                to_Shamsi: formatDateForApi(values.to_Shamsi),
                registration_From_Shamsi: formatDateForApi(values.registration_From_Shamsi),
                registration_To_Shamsi: formatDateForApi(values.registration_To_Shamsi),
                adminRegistration_From_Shamsi: formatDateForApi(values.adminRegistration_From_Shamsi),
                adminRegistration_To_Shamsi: formatDateForApi(values.adminRegistration_To_Shamsi),
                takeDocuments_From_Shamsi: formatDateForApi(values.takeDocuments_From_Shamsi),
                takeDocuments_To_Shamsi: formatDateForApi(values.takeDocuments_To_Shamsi),
                lotteryDate_Shamsi: values.lotteryDate_Shamsi ? formatDateForApi(values.lotteryDate_Shamsi) : "",
                comment: comment,
                additionalFileComment: additionalFileComment,
                categoryTitle: "",
            };

            let data = await Add_Period_Api(formattedValues);
            setLoading(false);
            
            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful");
                rowInserted();
            } else {
                showMessage(data.message, "error");
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error");
        }
    };

    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error");
    };

    // =================================================================
    const renderDatePicker = (name, label) => (
        <Form.Item
            name={name}
            label={label}
            rules={[{ required: true, message: 'یک مقدار معتبر وارد کنید!' }]}
        >
            <DatePicker
                calendar={persian}
                locale={persian_fa}
                format="YYYY-MM-DD"
                onChange={(dateObject) => form.setFieldsValue({ [name]: dateObject })}
            />
        </Form.Item>
    );

    // =================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2>
                    ایجاد دوره جدید
                </h2>
            </div>
            <div className='container'>
                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 19 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="id"
                        hidden={true}
                    />
                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ required: true, message: 'عنوان را وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>
                    <Form.Item
                        name="subTitle1"
                        label="زیر عنوان1"
                    >
                        <Input placeholder='زیر عنوان1' />
                    </Form.Item>

                    <Form.Item
                        name="subTitle2"
                        label="زیر عنوان2"
                    >
                        <Input placeholder='زیر عنوان2' />
                    </Form.Item>
                    
                    {renderDatePicker("from_Shamsi", "از تاریخ")}
                    {renderDatePicker("to_Shamsi", "تا تاریخ")}
                    {renderDatePicker("registration_From_Shamsi", "ثبت نام از تاریخ")}
                    {renderDatePicker("registration_To_Shamsi", "ثبت نام تا تاریخ")}
                    {renderDatePicker("adminRegistration_From_Shamsi", "ثبت نام مدیر از تاریخ")}
                    {renderDatePicker("adminRegistration_To_Shamsi", "ثبت نام مدیر تا تاریخ")}
                    {renderDatePicker("takeDocuments_From_Shamsi", "تحویل مدارک از تاریخ")}
                    {renderDatePicker("takeDocuments_To_Shamsi", "تحویل مدارک تا تاریخ")}

                    <Form.Item
                        name="categoryId"
                        hidden={true}
                    />
                    <Form.Item
                        name="isLottery"
                        label="آیا قرعه کشی دارد؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="lotteryDate_Shamsi"
                        label="تاریخ قرعه کشی"
                    >
                        <DatePicker
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY-MM-DD"
                            onChange={(dateObject) => form.setFieldsValue({ lotteryDate_Shamsi: dateObject })}
                        />
                    </Form.Item>

                    <Form.Item
                        label="تعداد ثبت نام قرعه کشی"
                        name="numberOfReserveForLottery"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="isTimesFix"
                        label="آیا تایم فیکس است؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        label="حداکثر شب مجاز"
                        name="maxNight"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="forceEnterOther"
                        label="گرفتن اطلاعات همراهان؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="getOthersPhoto"
                        label="گرفتن تصویر از همراهان؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="forceGetOthersPhoto"
                        label="اجبار در گرفتن تصویر همراهان؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="canReserveForOther"
                        label="اجازه رزرو برای دیگری؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label="توضیحات"
                    >
                        <ReactQuill
                            value={comment}
                            onChange={setComment}
                            placeholder="متن خود را وارد کنید..."
                            theme="snow"
                        />
                    </Form.Item>

                    <Form.Item
                        name="getAdditionalFile"
                        label="مرحله بارگذاری مدارک دارد؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="additionalFileMaxSize"
                        label="ماکزیمم سایز مجاز فایل"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="additionalFileCount"
                        label="ماکزیمم تعداد فایل مجاز"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="additionalFileComment"
                        label="توضیحات مرحله بارگذاری مدارک"
                    >
                        <ReactQuill
                            value={additionalFileComment}
                            onChange={setAdditionalFileComment}
                            placeholder="متن خود را وارد کنید..."
                            theme="snow"
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="havePayment"
                        label="مرحله پرداخت دارد؟"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enablePayByFish"
                        label="پرداخت با ثبت فیش"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enableElectronicPay"
                        label="پرداخت الکترونیک"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enableFoodReserve"
                        label="رزرو غذا دارد"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enableParkingReserve"
                        label="رزرو پارکینگ دارد"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enablePayByFish_FoodAndParking"
                        label="پرداخت غذا/پارکینگ با فیش"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="enableElectronicPay_FoodAndParking"
                        label="پرداخت الکترونیک غذا/پارکینگ"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>

                    <Form.Item
                        name="isActive"
                        label="فعال"
                        valuePropName='checked'
                    >
                        <Checkbox />
                    </Form.Item>
                </Form>
            </div>

            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}
                    >
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4}>
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={cancelInsert}
                    >
                        <RollbackOutlined />
                        لغو
                    </Button>
                </Col>
            </Row>
        </>
    );
};